import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllInternshipLocationsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllInternshipLocations
  implements GetAllInternshipLocationsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllInternshipLocationsUseCaseInterface.Params,
  ): Promise<GetAllInternshipLocationsUseCaseInterface.Result> {
    const { page, length, ...restParams } = params;

    const requestUrl = `${this.url}/${page}/${length}`;

    const httpResponse = await this.httpClient.request({
      url: generateUrl(requestUrl, restParams),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
